/* Sellō: interacciones del panel. Vanilla, sin librerías. */
(function () {
  'use strict';

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Display de 7 segmentos ---------- */
  var SEGS = {
    '0': 'abcdef', '1': 'bc', '2': 'abged', '3': 'abgcd', '4': 'fgbc', '5': 'afgcd',
    '6': 'afgedc', '7': 'abc', '8': 'abcdefg', '9': 'abcdfg', '-': 'g', ' ': ''
  };

  function pintarDisplay(el, texto) {
    var digitos = el.querySelectorAll('.mt-digito');
    var t = String(texto);
    while (t.length < digitos.length) t = ' ' + t;
    t = t.slice(-digitos.length);
    digitos.forEach(function (svg, i) {
      var segs = SEGS[t.charAt(i)] || '';
      svg.querySelectorAll('polygon').forEach(function (p) {
        p.classList.toggle('on', segs.indexOf(p.getAttribute('data-s')) !== -1);
      });
    });
  }

  function valorDisplay(el) {
    return el.getAttribute('data-valor') || el.getAttribute('aria-label') || '';
  }

  /* ---------- Arranque: prueba de encendido y barrido de sellado ---------- */
  function initArranque() {
    document.querySelectorAll('.mt-hero').forEach(function (hero) {
      if (reducido) return;
      hero.classList.add('mt-arranca');
      var d = hero.querySelector('[data-mt-arranque]');
      if (!d) return;
      var final = valorDisplay(d);
      var n = d.querySelectorAll('.mt-digito').length;
      pintarDisplay(d, '8888888888'.slice(0, n));
      var fijados = 0;
      var parpadeo = setInterval(function () {
        var t = '';
        for (var i = 0; i < n; i++) {
          if (i < fijados) {
            var f = final;
            while (f.length < n) f = ' ' + f;
            t += f.charAt(i);
          } else {
            t += String(Math.floor(Math.random() * 10));
          }
        }
        pintarDisplay(d, t);
      }, 55);
      setTimeout(function () {
        var paso = setInterval(function () {
          fijados++;
          if (fijados >= n) {
            clearInterval(paso);
            clearInterval(parpadeo);
            pintarDisplay(d, final);
          }
        }, 120);
      }, 650);
    });
  }

  /* ---------- Ciclo controlado por el scroll ---------- */
  function initCiclo() {
    document.querySelectorAll('.mt-ciclo--animado').forEach(function (sec) {
      var pista = sec.querySelector('.mt-ciclo__pista');
      var pasos = Array.prototype.slice.call(sec.querySelectorAll('.mt-paso'));
      var teclas = Array.prototype.slice.call(sec.querySelectorAll('.mt-maquina__teclas .mt-tecla'));
      var display = sec.querySelector('.mt-maquina [data-mt-display]');
      var segs = Array.prototype.slice.call(sec.querySelectorAll('.mt-barra__segmentos i'));
      var calor = sec.querySelector('.mt-resistencia');
      if (!pista || !pasos.length) return;
      var n = pasos.length;
      var ultimo = '';

      function fase(i) { return pasos[i] ? pasos[i].getAttribute('data-fase') : ''; }
      function indiceDe(f) { for (var i = 0; i < n; i++) if (fase(i) === f) return i; return -1; }
      var iVacio = indiceDe('vacio');
      var iSella = indiceDe('sella');

      function actualizar() {
        var r = pista.getBoundingClientRect();
        var recorrido = r.height - window.innerHeight;
        var p = recorrido > 0 ? Math.min(1, Math.max(0, -r.top / recorrido)) : 0;
        var pos = p * n;
        var activo = Math.min(n - 1, Math.floor(pos));
        var local = Math.min(1, pos - activo);

        pasos.forEach(function (el, i) { el.classList.toggle('is-activo', i === activo); });
        teclas.forEach(function (el, i) {
          el.classList.toggle('is-activa', i === activo);
          el.classList.toggle('is-hecha', i < activo);
        });

        var vacio = 0;
        if (iVacio >= 0) vacio = activo > iVacio ? 1 : activo === iVacio ? local : 0;
        var encendidos = Math.round(vacio * segs.length);
        segs.forEach(function (s, i) { s.classList.toggle('on', i < encendidos); });

        var c = 0;
        if (iSella >= 0) {
          if (activo === iSella) c = Math.min(1, local * 1.4);
          else if (activo > iSella) c = Math.max(0, 1 - local * 1.6 - (activo - iSella - 1));
        }
        if (calor) calor.style.setProperty('--mt-calor', c.toFixed(3));

        var pct = String(Math.round(p * 100));
        if (display && pct !== ultimo) { pintarDisplay(display, pct); ultimo = pct; }
      }

      var pendiente = false;
      function alScroll() {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () { pendiente = false; actualizar(); });
      }
      window.addEventListener('scroll', alScroll, { passive: true });
      window.addEventListener('resize', alScroll);
      actualizar();
    });
  }

  /* ---------- Modos (pestañas) ---------- */
  function initModos() {
    document.querySelectorAll('[data-mt-modos]').forEach(function (sec) {
      var tabs = Array.prototype.slice.call(sec.querySelectorAll('[role="tab"]'));
      var paneles = Array.prototype.slice.call(sec.querySelectorAll('[role="tabpanel"]'));
      function activar(i, foco) {
        tabs.forEach(function (t, j) {
          var si = i === j;
          t.setAttribute('aria-selected', si ? 'true' : 'false');
          t.tabIndex = si ? 0 : -1;
        });
        paneles.forEach(function (p, j) {
          p.hidden = i !== j;
          p.classList.remove('is-entrando');
          if (i === j) { void p.offsetWidth; p.classList.add('is-entrando'); }
        });
        if (foco) tabs[i].focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activar(i, false); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var d = e.key === 'ArrowRight' ? 1 : -1;
            activar((i + d + tabs.length) % tabs.length, true);
          }
        });
      });
    });
  }

  /* ---------- Medidores de frescura ---------- */
  function initMedidores() {
    var filas = document.querySelectorAll('[data-mt-medidor]');
    if (!filas.length) return;

    function visibles(cont) {
      return Array.prototype.slice.call(cont.querySelectorAll('i')).filter(function (i) { return i.offsetParent !== null; });
    }

    function animar(fila) {
      var normal = parseFloat(fila.getAttribute('data-normal')) || 0;
      var vacio = parseFloat(fila.getAttribute('data-vacio')) || 0;
      var max = Math.max(normal, vacio, 1);
      var segN = visibles(fila.querySelector('.mt-medidor__segs--normal'));
      var segV = visibles(fila.querySelector('.mt-medidor__segs--vacio'));
      var metaN = Math.max(1, Math.round((normal / max) * segN.length));
      var metaV = Math.max(1, Math.round((vacio / max) * segV.length));
      var numN = fila.querySelector('[data-mt-num="normal"]');
      var numV = fila.querySelector('[data-mt-num="vacio"]');
      var dur = reducido ? 0 : 1400;
      var t0 = performance.now();

      function paso(ahora) {
        var t = dur ? Math.min(1, (ahora - t0) / dur) : 1;
        var e = 1 - Math.pow(1 - t, 4);
        var eV = t < 1 ? 1 - Math.pow(1 - t, 3) * Math.cos(t * 3.2) : 1;
        var cn = Math.round(metaN * Math.min(1, e));
        var cv = Math.round(metaV * Math.min(1, Math.max(0, eV)));
        segN.forEach(function (s, i) { s.classList.toggle('on', i < cn); });
        segV.forEach(function (s, i) { s.classList.toggle('on', i < cv); });
        if (numN) numN.textContent = Math.round(normal * Math.min(1, e));
        if (numV) numV.textContent = Math.round(vacio * Math.min(1, e));
        if (t < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) { filas.forEach(animar); return; }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (en.isIntersecting) { io.unobserve(en.target); animar(en.target); }
      });
    }, { threshold: 0.4 });
    filas.forEach(function (f) { io.observe(f); });
  }

  /* ---------- Galería de producto ---------- */
  function initGaleria() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (g) {
      var principal = g.querySelector('.mt-galeria__principal img');
      var video = g.querySelector('.mt-galeria__video');
      var minis = g.querySelectorAll('.mt-miniatura');
      if (!principal) return;
      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          minis.forEach(function (o) { o.setAttribute('aria-current', 'false'); });
          m.setAttribute('aria-current', 'true');
          var vsrc = m.getAttribute('data-video');
          if (video && vsrc) {
            if (video.getAttribute('src') !== vsrc) video.src = vsrc;
            video.poster = m.getAttribute('data-src') || '';
            video.hidden = false;
            principal.style.opacity = '0';
            var pr = video.play(); if (pr && pr.catch) pr.catch(function () {});
            return;
          }
          if (video && !video.hidden) { video.pause(); video.hidden = true; }
          principal.style.opacity = '0';
          var src = m.getAttribute('data-src');
          var srcset = m.getAttribute('data-srcset');
          var alt = m.getAttribute('data-alt') || '';
          setTimeout(function () {
            if (srcset) principal.setAttribute('srcset', srcset);
            principal.src = src;
            principal.alt = alt;
            principal.style.opacity = '1';
          }, 160);
        });
      });
    });
  }

  /* ---------- Variantes ---------- */
  function initVariantes() {
    document.querySelectorAll('[data-mt-variantes]').forEach(function (cont) {
      var json = cont.querySelector('script[type="application/json"]');
      if (!json) return;
      var variantes = JSON.parse(json.textContent);
      var raiz = cont.closest('.mt-producto') || document;
      cont.addEventListener('change', function () {
        var elegidas = [];
        cont.querySelectorAll('fieldset').forEach(function (fs) {
          var sel = fs.querySelector('input:checked');
          elegidas.push(sel ? sel.value : null);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        document.querySelectorAll('[data-mt-variante]').forEach(function (inp) { if (v) inp.value = v.id; });
        document.querySelectorAll('.mt-compra button[name="add"]').forEach(function (btn) {
          var txt = btn.querySelector('[data-mt-compra-texto]');
          var ok = v && v.available;
          btn.disabled = !ok;
          if (ok) btn.removeAttribute('aria-disabled'); else btn.setAttribute('aria-disabled', 'true');
          if (txt && txt.firstChild) txt.firstChild.textContent = ok ? (btn.getAttribute('data-texto') || 'Comprar') : (v ? 'Agotado' : 'No disponible');
        });
        if (v) {
          var entero = String(Math.floor(v.price / 100));
          raiz.querySelectorAll('.mt-precio__display').forEach(function (d) { pintarDisplay(d, entero); d.setAttribute('aria-label', entero); });
          var antes = raiz.querySelector('[data-mt-precio-antes]');
          if (antes) {
            antes.hidden = !(v.compare_at_price && v.compare_at_price > v.price);
            if (!antes.hidden) antes.textContent = antes.getAttribute('data-prefijo') + (v.compare_at_price / 100).toLocaleString('es-MX');
          }
          if (window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          }
        }
      });
    });
  }

  /* ---------- Barra de compra fija ---------- */
  function initBarraCompra() {
    var barra = document.querySelector('.mt-barra-compra');
    if (!barra) return;
    if (barra.hasAttribute('data-siempre')) {
      document.body.classList.add('mt-con-barra');
      setTimeout(function () { barra.classList.add('is-visible'); }, 300);
      return;
    }
    var ancla = document.querySelector('[data-mt-ancla-compra]');
    if (!ancla || !('IntersectionObserver' in window)) return;
    var anclaVisible = true;
    var cierreVisible = false;
    function pintar() { barra.classList.toggle('is-visible', !anclaVisible && !cierreVisible); }
    new IntersectionObserver(function (e) {
      anclaVisible = e[0].isIntersecting || e[0].boundingClientRect.top > 0;
      pintar();
    }).observe(ancla);
    var cierre = document.querySelector('.mt-cierre, .mt-pie');
    if (cierre) {
      new IntersectionObserver(function (e) { cierreVisible = e[0].isIntersecting; pintar(); }, { threshold: 0.1 }).observe(cierre);
    }
  }


  /* ---------- Reseñas: carga de fotos de Judge.me en nuestra sección ---------- */
  function initResenas() {
    var sec = document.querySelector('.mt-resenas');
    if (!sec) return;
    function cargar() {
      sec.querySelectorAll('img.jdgm-rev__pic-img[data-src]').forEach(function (img) {
        if (!img.getAttribute('src')) {
          img.loading = 'lazy';
          img.src = img.getAttribute('data-src');
          var a = img.closest('.jdgm-rev__pic-link');
          if (a) a.classList.remove('jdgm--loading');
        }
      });
    }
    cargar();
    if ('MutationObserver' in window) new MutationObserver(cargar).observe(sec, { childList: true, subtree: true });
  }

  /* ---------- Video "Mírala funcionar": se reproduce solo cuando se ve ---------- */
  function initVideoSeccion() {
    document.querySelectorAll('[data-mt-video]').forEach(function (v) {
      if (reducido) { v.removeAttribute('autoplay'); v.controls = true; return; }
      if (!('IntersectionObserver' in window)) { v.play && v.play(); return; }
      new IntersectionObserver(function (e) {
        e.forEach(function (en) {
          if (en.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: 0.35 }).observe(v);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initArranque();
    initCiclo();
    initModos();
    initMedidores();
    initGaleria();
    initVariantes();
    initBarraCompra();
    initResenas();
    initVideoSeccion();
  });

  /* En el editor de Shopify las secciones se recargan: reiniciar */
  document.addEventListener('shopify:section:load', function () {
    initCiclo();
    initModos();
    initMedidores();
    initGaleria();
    initVariantes();
  });
})();
